import React, { type ReactNode } from "react";
import { Root as RadixRoot } from "@radix-ui/react-dialog";

import { ModalContent } from "./modal-content";
import { ModalTrigger } from "./modal-trigger";

export type ModalProps = {
  ["data-testid"]?: string;
  children: ReactNode;
  /**
   * Event handler called when the open state of the dialog changes.
   * */
  onOpenChange?: (value: boolean) => void;
  /**
   * The controlled open state of the dialog. Must be used in conjunction with `onOpenChange`.
   * */
  open?: boolean;
};

export const Modal = ({
  ["data-testid"]: dataTestId,
  children,
  open,
  onOpenChange,
}: ModalProps) => (
  <RadixRoot open={open} onOpenChange={onOpenChange} data-testid={dataTestId}>
    {children}
  </RadixRoot>
);

Modal.Trigger = ModalTrigger;
Modal.Content = ModalContent;

Modal.displayName = "Modal";
